import { render, staticRenderFns } from "./SharingOptions.vue?vue&type=template&id=4a2e98a4&"
import script from "./SharingOptions.vue?vue&type=script&lang=js&"
export * from "./SharingOptions.vue?vue&type=script&lang=js&"
import style0 from "./SharingOptions.vue?vue&type=style&index=0&id=4a2e98a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports